export const translations = {
  es: {
    nav: {
      home: "Inicio",
      products: "Productos",
      about: "Nosotros",
      process: "Proceso",
      sectors: "Sectores",
      coverage: "Cobertura",
      blog: "Recursos",
      faq: "Preguntas",
      quote: "Cotizar",
      contact: "Contacto",
      portal: "Portal Cliente",
      cta: "Solicitar Cotización",
    },
    promoBar: [
      "Envíos en 24h en CDMX, Monterrey y Guadalajara",
      "Cotiza en menos de 24 horas con un asesor especializado",
      "Stock garantizado · COFEPRIS · ISO 13485",
      "Distribución a México, Estados Unidos y Canadá",
    ],
    interludes: {
      clinic: {
        eyebrow: "Calidad hospitalaria",
        title: "Cuando cada minuto cuenta, el insumo no puede faltar.",
        body: "Productos certificados, trazabilidad por lote y disponibilidad continua para los equipos clínicos que sostienen la operación.",
      },
      borders: {
        eyebrow: "Logística sin fronteras",
        title: "Tres países, un solo proveedor.",
        body: "México, Estados Unidos y Canadá conectados por una red de almacenes Triple A, transporte controlado y trazabilidad punto a punto.",
      },
    },
    stories: {
      eyebrow: "Cómo entregamos valor",
      title: "Tres compromisos detrás de cada pedido.",
      items: [
        {
          tag: "Stock real",
          title: "Inventario auditado en tiempo real.",
          body: "Conexión directa con nuestros tres almacenes Triple A. Sabes qué tenemos antes de cotizar; nunca se promete lo que no se puede entregar.",
          image:
            "https://images.pexels.com/photos/4483608/pexels-photo-4483608.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "99.4%",
          statLabel: "exactitud de inventario",
        },
        {
          tag: "Equipo dedicado",
          title: "Un asesor que conoce tu institución.",
          body: "Asignamos un punto de contacto único que entiende tu historial de compra, rutas, tiempos críticos y formato de licitación.",
          image:
            "https://images.pexels.com/photos/3938022/pexels-photo-3938022.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "<24h",
          statLabel: "tiempo de respuesta",
        },
        {
          tag: "Cadena fría",
          title: "Lo sensible llega controlado.",
          body: "Transporte refrigerado, sensores IoT en cada caja y trazabilidad punto a punto para reactivos, vacunas y consumibles termolábiles.",
          image:
            "https://images.pexels.com/photos/3825572/pexels-photo-3825572.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "+2 a +8°C",
          statLabel: "rango monitoreado",
        },
      ],
    },
    hero: {
      eyebrow: "Distribuidor médico mexicano",
      title: "Insumos médicos confiables, entregados a tiempo.",
      subtitle:
        "ICOR distribuye insumos desechables certificados a hospitales, clínicas y consultorios en toda Norteamérica. Calidad clínica, logística sin fricción.",
      ctaPrimary: "Solicitar cotización",
      ctaSecondary: "Ver catálogo",
      stat1: "Norteamérica",
      stat1Label: "MX · US · CA",
      stat2: "24-72",
      stat2Suffix: "h",
      stat2Label: "entrega típica",
      stat3: "32",
      stat3Label: "estados con cobertura",
    },
    values: {
      eyebrow: "Por qué ICOR",
      title: "Tres pilares para tu operación médica.",
      items: [
        {
          title: "Calidad certificada",
          desc: "Productos avalados por COFEPRIS y normas internacionales, trazabilidad por lote.",
          icon: "ShieldCheck",
        },
        {
          title: "Logística nacional",
          desc: "Centros de distribución en CDMX, Monterrey y Guadalajara. Entregas en 24–72h.",
          icon: "Truck",
        },
        {
          title: "Precio competitivo",
          desc: "Compra directa al fabricante. Cotizaciones por volumen para sector público y privado.",
          icon: "ChartLineUp",
        },
      ],
    },
    catalog: {
      eyebrow: "Catálogo",
      title: "Insumos desechables para todo el flujo clínico.",
      subtitle:
        "Desde guantes y jeringas hasta equipos de venoclisis. Stock permanente, calidad hospitalaria.",
      cta: "Cotizar esta categoría",
    },
    about: {
      eyebrow: "Nosotros",
      title: "Una red mexicana al servicio de la salud.",
      p1: "ICOR nace en México con un objetivo claro: simplificar el abasto de insumos médicos para hospitales, clínicas y consultorios. Compramos directamente a fabricantes nacionales e internacionales, controlamos la cadena logística y entregamos en toda Norteamérica.",
      p2: "Nuestro equipo combina experiencia clínica, logística y compras estratégicas para que tu institución nunca se quede sin lo esencial.",
      bullet1: "Almacenes de categoría Triple A",
      bullet2: "Trazabilidad por lote y caducidad",
      bullet3: "Atención a sector público y privado",
      bullet4: "Facturación electrónica CFDI 4.0",
      metricLabel: "tasa de entrega a tiempo",
    },
    process: {
      eyebrow: "Cómo trabajamos",
      title: "Un proceso simple, sin sorpresas.",
      subtitle:
        "Cuatro pasos diseñados para que tu institución reciba lo que necesita, cuando lo necesita.",
      steps: [
        {
          n: "01",
          title: "Cotización",
          desc: "Envíanos tu requerimiento y recibe una propuesta detallada en menos de 24 horas, con precios, alternativas y disponibilidad.",
        },
        {
          n: "02",
          title: "Aprobación y orden",
          desc: "Confirmamos lotes, caducidades y certificados. Generamos orden de compra con CFDI 4.0 y términos claros.",
        },
        {
          n: "03",
          title: "Entrega controlada",
          desc: "Despacho desde el almacén más cercano. Entregas en 24–72h con seguimiento en tiempo real y firma de recepción.",
        },
        {
          n: "04",
          title: "Soporte post-venta",
          desc: "Reposición proactiva, reportes de consumo y atención dedicada para tu institución.",
        },
      ],
    },
    sectors: {
      eyebrow: "Sectores que atendemos",
      title: "Trabajamos con cada eslabón del sistema de salud.",
      items: [
        {
          title: "Hospitales privados",
          desc: "Abasto continuo para áreas críticas, quirófano y hospitalización.",
          icon: "Buildings",
        },
        {
          title: "Sector público",
          desc: "Licitaciones, contratos marco y abasto para IMSS, ISSSTE y secretarías estatales.",
          icon: "Bank",
        },
        {
          title: "Clínicas y consultorios",
          desc: "Pedidos a la medida para práctica privada y centros de especialidad.",
          icon: "Stethoscope",
        },
        {
          title: "Farmacias y cadenas",
          desc: "Suministro mayorista de insumos desechables y EPP a precios competitivos.",
          icon: "Storefront",
        },
        {
          title: "Dental y veterinaria",
          desc: "Líneas especializadas para clínicas dentales y hospitales veterinarios.",
          icon: "Tooth",
        },
        {
          title: "Laboratorios",
          desc: "Consumibles certificados para diagnóstico clínico y patología.",
          icon: "TestTube",
        },
      ],
    },
    coverage: {
      eyebrow: "Cobertura",
      title: "Operamos en toda Norteamérica.",
      subtitle:
        "Tres centros de distribución en México y rutas activas a Estados Unidos y Canadá. Logística refrigerada cuando se requiere y trazabilidad punto a punto.",
      hubsTitle: "Hubs principales",
      hubs: [
        { city: "Ciudad de México", role: "HQ · Centro logístico" },
        { city: "Guadalajara", role: "Almacén Triple A" },
        { city: "Monterrey", role: "Almacén Triple A" },
        { city: "El Paso, TX", role: "Hub frontera norte" },
        { city: "Toronto, ON", role: "Hub Canadá" },
      ],
      countries: [
        { code: "MX", name: "México", coverage: "32 estados", flag: "🇲🇽" },
        { code: "US", name: "Estados Unidos", coverage: "Costa a costa", flag: "🇺🇸" },
        { code: "CA", name: "Canadá", coverage: "Principales provincias", flag: "🇨🇦" },
      ],
    },
    certifications: {
      eyebrow: "Certificaciones y cumplimiento",
      title: "Estándares que tu institución exige.",
      subtitle:
        "Cumplimos con la normativa mexicana e internacional para que tu compra sea siempre auditable y trazable.",
      items: [
        {
          name: "COFEPRIS",
          desc: "Registro sanitario vigente para todos los insumos distribuidos.",
        },
        {
          name: "ISO 13485",
          desc: "Sistema de gestión de calidad para dispositivos médicos.",
        },
        {
          name: "NOM-241",
          desc: "Buenas prácticas de fabricación y distribución de dispositivos médicos.",
        },
        {
          name: "CFDI 4.0",
          desc: "Facturación electrónica conforme al SAT, lista para gobierno y privado.",
        },
      ],
    },
    blog: {
      eyebrow: "Recursos",
      title: "Guías, normativas y tendencias del sector.",
      subtitle:
        "Contenido pensado para responsables de compras, jefes de enfermería y directores médicos.",
      readMore: "Leer artículo",
      viewAll: "Ver todos los recursos",
      backHome: "Volver al inicio",
      published: "Publicado",
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Lo que más nos preguntan.",
      items: [
        {
          q: "¿Cuál es el monto mínimo de orden?",
          a: "No manejamos un mínimo fijo. Coordinamos pedidos desde una caja hasta licitaciones de varios millones, ajustando precio y plazo de entrega según volumen.",
        },
        {
          q: "¿Realizan entregas urgentes?",
          a: "Sí. En CDMX, Monterrey y Guadalajara entregamos en 24 horas. Para emergencias hospitalarias coordinamos despacho mismo día.",
        },
        {
          q: "¿Trabajan con sector público (IMSS, ISSSTE, secretarías)?",
          a: "Participamos en licitaciones públicas, contratos marco y abasto a unidades de IMSS, ISSSTE y secretarías estatales. Manejamos toda la documentación requerida.",
        },
        {
          q: "¿Emiten facturación CFDI 4.0?",
          a: "Sí. Toda nuestra facturación cumple con CFDI 4.0 del SAT. Generamos factura inmediatamente al confirmar el pago o según los términos pactados.",
        },
        {
          q: "¿Qué certificaciones tienen sus productos?",
          a: "Todos los insumos cuentan con registro COFEPRIS vigente. Trabajamos bajo ISO 13485 y NOM-241. Compartimos certificados de análisis y trazabilidad por lote.",
        },
        {
          q: "¿Envían a Estados Unidos y Canadá?",
          a: "Sí. Operamos rutas regulares a USA (vía hub en El Paso, TX) y Canadá (vía hub en Toronto). Coordinamos importación, aduanas y cumplimiento regulatorio local.",
        },
      ],
    },
    quote: {
      eyebrow: "Solicita tu cotización",
      title: "Recibe una propuesta en menos de 24 horas.",
      subtitle:
        "Cuéntanos qué necesitas y un asesor especializado te contactará con precios, tiempos de entrega y disponibilidad.",
      name: "Nombre completo",
      company: "Institución / Empresa",
      email: "Correo electrónico",
      phone: "Teléfono",
      products: "Categorías de interés",
      message: "Detalle de tu requerimiento",
      messagePlaceholder: "Ej. 5,000 cajas de guantes nitrilo M, entrega en CDMX...",
      submit: "Enviar cotización",
      sending: "Enviando...",
      success: "¡Cotización enviada! Te contactaremos pronto.",
      error: "No se pudo enviar. Intenta de nuevo.",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Hablemos de tu próximo pedido.",
      phone: "+52 33 3844 4471",
      email: "ventas@icor.com.mx",
      address: "Av. Insurgentes Sur 1234, CDMX, México",
      hours: "Lun–Vie 9:00–18:00",
    },
    whatsapp: {
      label: "WhatsApp",
      tooltip: "Chatea con un asesor",
      message: "Hola ICOR, me interesa cotizar insumos médicos.",
    },
    portal: {
      title: "Portal Cliente",
      subtitle: "Accede a tu historial de pedidos, facturas y reposiciones.",
      email: "Correo corporativo",
      password: "Contraseña",
      submit: "Iniciar sesión",
      forgot: "¿Olvidaste tu contraseña?",
      coming: "El portal entra en operación próximamente. Mientras tanto, escribe a ventas@icor.com.mx para acceso anticipado.",
      back: "Volver al inicio",
      requestAccess: "Solicitar acceso anticipado",
    },
    footer: {
      tagline: "Distribución de insumos médicos en Norteamérica.",
      sections: {
        company: "Empresa",
        products: "Productos",
        legal: "Legal",
      },
      links: {
        about: "Nosotros",
        contact: "Contacto",
        quote: "Cotizar",
        privacy: "Aviso de privacidad",
        terms: "Términos",
        portal: "Portal Cliente",
        blog: "Recursos",
      },
      rights: "Todos los derechos reservados.",
    },
    theme: {
      toggleLight: "Cambiar a claro",
      toggleDark: "Cambiar a oscuro",
    },
  },
  en: {
    nav: {
      home: "Home",
      products: "Products",
      about: "About",
      process: "Process",
      sectors: "Sectors",
      coverage: "Coverage",
      blog: "Resources",
      faq: "FAQ",
      quote: "Quote",
      contact: "Contact",
      portal: "Client Portal",
      cta: "Request Quote",
    },
    promoBar: [
      "24h delivery in Mexico City, Monterrey and Guadalajara",
      "Get a quote in under 24 hours from a specialist advisor",
      "Guaranteed stock · COFEPRIS · ISO 13485",
      "Distribution to Mexico, United States and Canada",
    ],
    interludes: {
      clinic: {
        eyebrow: "Hospital grade",
        title: "When every minute counts, the supply cannot fail.",
        body: "Certified products, lot traceability and continuous availability for the clinical teams that keep operations running.",
      },
      borders: {
        eyebrow: "Logistics without borders",
        title: "Three countries, one supplier.",
        body: "Mexico, the United States and Canada connected by a network of Triple-A warehouses, controlled transport and end-to-end traceability.",
      },
    },
    stories: {
      eyebrow: "How we deliver value",
      title: "Three commitments behind every order.",
      items: [
        {
          tag: "Real stock",
          title: "Inventory audited in real time.",
          body: "Direct connection to our three Triple-A warehouses. You know what we hold before we quote — we never promise what we can't deliver.",
          image:
            "https://images.pexels.com/photos/4483608/pexels-photo-4483608.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "99.4%",
          statLabel: "inventory accuracy",
        },
        {
          tag: "Dedicated team",
          title: "An advisor who knows your institution.",
          body: "We assign a single point of contact who understands your purchase history, routes, critical timelines and tender format.",
          image:
            "https://images.pexels.com/photos/3938022/pexels-photo-3938022.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "<24h",
          statLabel: "response time",
        },
        {
          tag: "Cold chain",
          title: "Sensitive items arrive controlled.",
          body: "Refrigerated transport, IoT sensors per box and end-to-end traceability for reagents, vaccines and temperature-sensitive consumables.",
          image:
            "https://images.pexels.com/photos/3825572/pexels-photo-3825572.jpeg?auto=compress&cs=tinysrgb&w=1400",
          stat: "+2 to +8°C",
          statLabel: "monitored range",
        },
      ],
    },
    hero: {
      eyebrow: "Mexican medical distributor",
      title: "Reliable medical supplies, delivered on time.",
      subtitle:
        "ICOR distributes certified disposable medical supplies to hospitals, clinics and practices across North America. Clinical quality, frictionless logistics.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "View catalog",
      stat1: "North America",
      stat1Label: "MX · US · CA",
      stat2: "24-72",
      stat2Suffix: "h",
      stat2Label: "typical delivery time",
      stat3: "32",
      stat3Label: "states covered",
    },
    values: {
      eyebrow: "Why ICOR",
      title: "Three pillars for your medical operation.",
      items: [
        {
          title: "Certified quality",
          desc: "COFEPRIS-approved products and international standards, full lot traceability.",
          icon: "ShieldCheck",
        },
        {
          title: "Nationwide logistics",
          desc: "Distribution hubs in Mexico City, Monterrey and Guadalajara. 24–72h delivery.",
          icon: "Truck",
        },
        {
          title: "Competitive pricing",
          desc: "Direct from manufacturers. Volume pricing for public and private sectors.",
          icon: "ChartLineUp",
        },
      ],
    },
    catalog: {
      eyebrow: "Catalog",
      title: "Disposable supplies for every clinical workflow.",
      subtitle:
        "From gloves and syringes to IV kits. Permanent stock, hospital-grade quality.",
      cta: "Quote this category",
    },
    about: {
      eyebrow: "About",
      title: "A Mexican network serving healthcare.",
      p1: "ICOR was founded in Mexico with a clear mission: simplify medical supply procurement for hospitals, clinics and practices. We buy directly from national and international manufacturers, manage the supply chain and deliver across North America.",
      p2: "Our team blends clinical, logistics and strategic-sourcing expertise so your institution never runs out of the essentials.",
      bullet1: "Triple-A grade warehouses",
      bullet2: "Lot and expiration traceability",
      bullet3: "Public and private sector accounts",
      bullet4: "CFDI 4.0 electronic invoicing",
      metricLabel: "on-time delivery rate",
    },
    process: {
      eyebrow: "How we work",
      title: "A simple process, no surprises.",
      subtitle:
        "Four steps designed so your institution gets what it needs, when it needs it.",
      steps: [
        {
          n: "01",
          title: "Quote",
          desc: "Send us your requirement and receive a detailed proposal in under 24 hours with pricing, alternatives and availability.",
        },
        {
          n: "02",
          title: "Approval & PO",
          desc: "We confirm lots, expirations and certificates. Purchase order issued with CFDI 4.0 and clear terms.",
        },
        {
          n: "03",
          title: "Controlled delivery",
          desc: "Dispatch from the closest hub. 24–72h delivery with real-time tracking and signed receipt.",
        },
        {
          n: "04",
          title: "Post-sale support",
          desc: "Proactive replenishment, consumption reports and dedicated account management.",
        },
      ],
    },
    sectors: {
      eyebrow: "Sectors we serve",
      title: "We work with every link in the healthcare chain.",
      items: [
        {
          title: "Private hospitals",
          desc: "Continuous supply for critical care, OR and inpatient units.",
          icon: "Buildings",
        },
        {
          title: "Public sector",
          desc: "Tenders, framework contracts and supply for IMSS, ISSSTE and state ministries.",
          icon: "Bank",
        },
        {
          title: "Clinics & practices",
          desc: "Tailored orders for private practice and specialty centers.",
          icon: "Stethoscope",
        },
        {
          title: "Pharmacies & chains",
          desc: "Wholesale supply of disposables and PPE at competitive pricing.",
          icon: "Storefront",
        },
        {
          title: "Dental & veterinary",
          desc: "Specialized lines for dental clinics and veterinary hospitals.",
          icon: "Tooth",
        },
        {
          title: "Laboratories",
          desc: "Certified consumables for clinical diagnostics and pathology.",
          icon: "TestTube",
        },
      ],
    },
    coverage: {
      eyebrow: "Coverage",
      title: "We operate across all of North America.",
      subtitle:
        "Three distribution centers in Mexico and active routes to the United States and Canada. Cold-chain logistics when required and end-to-end traceability.",
      hubsTitle: "Main hubs",
      hubs: [
        { city: "Mexico City", role: "HQ · Logistics center" },
        { city: "Guadalajara", role: "Triple-A warehouse" },
        { city: "Monterrey", role: "Triple-A warehouse" },
        { city: "El Paso, TX", role: "North-border hub" },
        { city: "Toronto, ON", role: "Canada hub" },
      ],
      countries: [
        { code: "MX", name: "Mexico", coverage: "32 states", flag: "🇲🇽" },
        { code: "US", name: "United States", coverage: "Coast to coast", flag: "🇺🇸" },
        { code: "CA", name: "Canada", coverage: "Major provinces", flag: "🇨🇦" },
      ],
    },
    certifications: {
      eyebrow: "Certifications & compliance",
      title: "Standards your institution requires.",
      subtitle:
        "We comply with Mexican and international regulation so your purchase is always auditable and traceable.",
      items: [
        {
          name: "COFEPRIS",
          desc: "Active health registry for every product distributed.",
        },
        {
          name: "ISO 13485",
          desc: "Quality management system for medical devices.",
        },
        {
          name: "NOM-241",
          desc: "Good manufacturing and distribution practices for medical devices.",
        },
        {
          name: "CFDI 4.0",
          desc: "Electronic invoicing per SAT, ready for government and private buyers.",
        },
      ],
    },
    blog: {
      eyebrow: "Resources",
      title: "Guides, regulation and industry trends.",
      subtitle:
        "Content built for procurement leads, head nurses and medical directors.",
      readMore: "Read article",
      viewAll: "View all resources",
      backHome: "Back to home",
      published: "Published",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "What our clients ask the most.",
      items: [
        {
          q: "Is there a minimum order amount?",
          a: "No fixed minimum. We handle everything from a single box to multi-million tenders, adjusting pricing and delivery times to volume.",
        },
        {
          q: "Do you offer rush deliveries?",
          a: "Yes. In Mexico City, Monterrey and Guadalajara we deliver within 24 hours. For hospital emergencies we coordinate same-day dispatch.",
        },
        {
          q: "Do you work with the public sector (IMSS, ISSSTE, ministries)?",
          a: "We participate in public tenders, framework contracts and supply IMSS, ISSSTE and state ministries. We handle all required documentation.",
        },
        {
          q: "Do you issue CFDI 4.0 invoices?",
          a: "Yes. All our billing complies with SAT CFDI 4.0. Invoices are issued upon payment confirmation or per agreed terms.",
        },
        {
          q: "What certifications do your products have?",
          a: "Every product carries an active COFEPRIS registry. We operate under ISO 13485 and NOM-241. We share certificates of analysis and lot traceability.",
        },
        {
          q: "Do you ship to the United States and Canada?",
          a: "Yes. We run regular routes to the US (via El Paso, TX hub) and Canada (via Toronto hub). We coordinate import, customs and local regulatory compliance.",
        },
      ],
    },
    quote: {
      eyebrow: "Request a quote",
      title: "Get a proposal in under 24 hours.",
      subtitle:
        "Tell us what you need and a specialist will contact you with pricing, delivery times and availability.",
      name: "Full name",
      company: "Institution / Company",
      email: "Email",
      phone: "Phone",
      products: "Categories of interest",
      message: "Requirement details",
      messagePlaceholder: "E.g. 5,000 boxes of nitrile gloves M, delivery in CDMX...",
      submit: "Send request",
      sending: "Sending...",
      success: "Quote request sent! We'll contact you soon.",
      error: "Could not send. Please try again.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk about your next order.",
      phone: "+52 33 3844 4471",
      email: "ventas@icor.com.mx",
      address: "Av. Insurgentes Sur 1234, Mexico City, Mexico",
      hours: "Mon–Fri 9:00–18:00",
    },
    whatsapp: {
      label: "WhatsApp",
      tooltip: "Chat with an advisor",
      message: "Hi ICOR, I'm interested in a medical-supplies quote.",
    },
    portal: {
      title: "Client Portal",
      subtitle: "Access your order history, invoices and replenishments.",
      email: "Corporate email",
      password: "Password",
      submit: "Sign in",
      forgot: "Forgot your password?",
      coming: "The portal goes live soon. Meanwhile, email ventas@icor.com.mx for early access.",
      back: "Back to home",
      requestAccess: "Request early access",
    },
    footer: {
      tagline: "Medical-supplies distribution across North America.",
      sections: {
        company: "Company",
        products: "Products",
        legal: "Legal",
      },
      links: {
        about: "About",
        contact: "Contact",
        quote: "Quote",
        privacy: "Privacy notice",
        terms: "Terms",
        portal: "Client Portal",
        blog: "Resources",
      },
      rights: "All rights reserved.",
    },
    theme: {
      toggleLight: "Switch to light",
      toggleDark: "Switch to dark",
    },
  },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_6d3eeaaf-d969-4aed-977a-03253e86cd84/artifacts/o6d83l77_Logos%20ICOR.png";

export const WHATSAPP_NUMBER = "523338444471";
